import React, { useState } from "react";
import "./CarruselCategorias.css";
import imgLoader from "../Imagenes/Pedidos.jpg";
import { Tags } from "../../componentes/CarruselCategorias/Tags";
import Slider from "react-slick";
import styled from "styled-components";
import { Link } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { configShop } from '../../states/configShop';
export const CarrionGroup = (props) => {
  const { dataConfig } = configShop();
  const { openCategories, products, title, image } = props;
  const codigoPais = "es-CO";
  const codigoCurrency = "COP";
  const formatter = new Intl.NumberFormat(codigoPais, {
    style: "currency",
    currency: codigoCurrency, // Puedes cambiar a 'USD', 'GBP', etc. según la moneda que necesites
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
  // settings es el responsive del carrusel o scroll horizontal.
  const settings = {
    dots: false,          // puntos de navegación abajo
    infinite: true,      // loop infinito
    speed: 500,          // velocidad de transición
    slidesToShow: 1,     // cuántos se muestran
    slidesToScroll: 1,   // cuántos se mueven por vez
    autoplay: true,      // autoplay activado
    autoplaySpeed: 3000, // cada 3 segundos
    variableWidth: true,
  };
  return (
    <div className="CarruselCategorias">
      <div className="carrion-label color-text" style={{ "--btn-font-color": dataConfig?.color_font }}>
        {image
          ? <img
            src={image}
            alt="fotoComida"
            style={{
              maxWidth: "100%",
              marginBottom: "10px",
              borderRadius: "7px",
              objectFit: "cover",
              maxHeight: " 150px",
            }}
          ></img>
          : <h2 className="h4">{title}</h2>
        }</div>
      <Slider {...settings}>
        {(Array.isArray(openCategories) ? openCategories : []).map((item, i) => {
          return (
            <Link
              to={"/detail/" + item.uuid}
              style={{ textDecoration: "none" }}
              key={item.uuid}
            >
              <div
                className="carrion-card"
                key={item.uuid}
                style={{
                  "--color-botton": dataConfig?.color_botton,
                  "--color-button-text": dataConfig?.color_button_text,
                  "--btn-font-color": dataConfig?.color_font,
                  "--color-price": dataConfig?.page_menu?.color_price,
                }}
              >
                <div className="carrion-card-top">
                  <img
                    src={item.photo}
                    alt="imagen"
                    className="imagenCategoria"
                  />
                  {item.tags !== undefined && (
                    <Tags tag={item.tags} className={"carrion-tag"} />
                  )}
                  <div className="carrion-price" >
                    {formatter.format(item.price)}
                  </div>
                </div>
                <div className="carrion-informacion color-text">{item.name}</div>
              </div>
            </Link>
          );
        })}
      </Slider>
    </div>
  );
};
